import type {classroomByDescriptor_classroomByDescriptorV2_students as GqlStudent} from "#reports/course-mastery/__graphql-types__/classroomByDescriptor.ts";
import type {courseMasteryTargets_districtById_goal_courseMasteryTargets as GqlCourseMasteryTarget} from "#reports/course-mastery/__graphql-types__/courseMasteryTargets.ts";
import type {csvReportStatus_getLastNAdminReportsForUser_adminReports as GqlAdminReportVariables} from "#reports/export-csvs/__graphql-types__/csvReportStatus.ts";
import type {
    requestAdminReportCSV_requestAdminReportCSV as GqlRequestAdminReportCSV,
    requestAdminReportCSVVariables as GqlRequestAdminReportCSVVariables,
} from "#reports/export-csvs/__graphql-types__/requestAdminReportCSV.ts";

export type CourseMasteryTarget = GqlCourseMasteryTarget;

export type AdminReportType = GqlRequestAdminReportCSVVariables["reportType"];
export type RequestAdminReportCSV = GqlRequestAdminReportCSV;
export type RequestAdminReportCSVVariables = GqlRequestAdminReportCSVVariables;

export type AdminReport = GqlAdminReportVariables;

export type Student = GqlStudent;

type CSVReport = Record<
    GqlRequestAdminReportCSVVariables["reportType"],
    GqlRequestAdminReportCSVVariables["reportType"]
>;

export const CSVReportType: CSVReport = {
    OVERALL_DI2: "OVERALL_DI2",
    MAP_DI2: "MAP_DI2",
    KAD_SKILLS_PROGRESS: "KAD_SKILLS_PROGRESS",
    MAP_SKILLS_PROGRESS: "MAP_SKILLS_PROGRESS",
    MASTERY_STUDENT: "MASTERY_STUDENT",
    MASTERY_CLASS: "MASTERY_CLASS",
    KHANMIGO_USAGE: "KHANMIGO_USAGE",
    COURSE_CHALLENGE_SKILLS: "COURSE_CHALLENGE_SKILLS",
} as const;

export type ActivityNameData = {
    aiReportingLabel: {translatedTitle: string} | null | undefined;
    aIGuideActivity: {translatedTitle: string} | null | undefined;
    activityType: string;
};

export type TargetStatus = "ABOVE_TARGET" | "ON_TARGET" | "BELOW_TARGET";

export enum SourceDashboard {
    TEACHER = "TEACHER",
    DISTRICT = "ADMIN",
    PARENT = "PARENT",
}

export enum Domain {
    ALL = "ALL",
    MATH = "MATH",
    SAT = "SAT",
}

export type DomainMapping = Record<Domain, string>;

export const DomainMappings: DomainMapping = {
    ALL: "",
    MATH: "x7a488390",
    SAT: "x7626d097",
} as const;
